module.exports = __webpack_public_path__ + "img/default-avatar.b48f5ba.webp";